export default __webpack_public_path__ + "static/media/Imperial-Fleet-02.5cfe8644.jpg";